import { render, staticRenderFns } from "./add-edit-maintenance.vue?vue&type=template&id=c81aeb4a&scoped=true"
import script from "./add-edit-maintenance.vue?vue&type=script&lang=js"
export * from "./add-edit-maintenance.vue?vue&type=script&lang=js"
import style0 from "./add-edit-maintenance.vue?vue&type=style&index=0&id=c81aeb4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81aeb4a",
  null
  
)

export default component.exports